module.exports = __webpack_public_path__ + "static/img/mode-video@2x.e0e76efc.png";